export default "__VITE_ASSET__fcf622fa__"